var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.6875 4.46836L15.75 4.5C15.7641 4.5 15.7816 4.5 15.7957 4.5C16.1895 4.51055 16.5551 4.62656 16.875 4.81289V4.80234C17.5465 5.18906 18 5.9168 18 6.75V14.625C18 15.866 16.991 16.875 15.75 16.875H2.25C1.00723 16.875 0 15.866 0 14.625V2.8125C0 3.74414 0.755508 4.5 1.6875 4.5V4.46836ZM14.625 11.8125C15.2473 11.8125 15.75 11.3098 15.75 10.6875C15.75 10.0652 15.2473 9.5625 14.625 9.5625C14.0027 9.5625 13.5 10.0652 13.5 10.6875C13.5 11.3098 14.0027 11.8125 14.625 11.8125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M0 2.8125C0 1.88051 0.755508 1.125 1.6875 1.125H15.1875C16.1191 1.125 16.875 1.88051 16.875 2.8125V4.80234C16.5445 4.60898 16.1613 4.5 15.75 4.5H1.6875C0.755508 4.5 0 3.74414 0 2.8125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.d3ab60a5b65505a77814b62444209bc1.svg";
export { ForwardRef as ReactComponent };